<app-layout *ngIf="!loginUnavailable(); else loginUnavailableView"></app-layout>
<ng-template #loginUnavailableView>
    <div class="flex min-h-screen flex-col items-center justify-center gap-4 p-4">
        <app-feedback-banner
            variant="error"
            i18n-header
            header="Login service unavailable"
            i18n-message
            message="The login service could not be reached. Please try again."
        ></app-feedback-banner>
        <button type="button" class="btn btn-primary" (click)="reload()" i18n>Try again</button>
    </div>
</ng-template>
